module.exports = __webpack_public_path__ + "img/inspiration.dc4204c.jpg";